import { CREATOR_CRITERIA } from '../constants';
import * as styled from '../styles/criteria-grid';
import { SectionHeading } from './section-heading';

export const CriteriaGrid = () => (
  <styled.Wrap>
    <SectionHeading
      kicker="Before they shortlist you"
      title="What brands actually check."
      subtitle="We asked people who book creators for a living. Your page is built around their answers."
      align="center"
    />
    <styled.Grid>
      {CREATOR_CRITERIA.map((criterion) => (
        <styled.Card key={criterion.number}>
          <styled.TopRow>
            <styled.Number $highlight={criterion.accent === 'highlight'}>
              {criterion.number}
            </styled.Number>
            <styled.Title>{criterion.title}</styled.Title>
          </styled.TopRow>
          <styled.Description>{criterion.description}</styled.Description>
        </styled.Card>
      ))}
    </styled.Grid>
  </styled.Wrap>
);
